import "./SingleWineTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleWineTemplateSection from "./sections/SingleWineTemplateSection"
import PieDePagina from "@/reusable_sections/Footer"

export default function SingleWineTemplatePage() {

  return (
    <div>
      <Header />
      <SingleWineTemplateSection />
      <PieDePagina />
    </div>
  )
}
